import React, { useState } from "react";

function Faq() {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "How does NexEra Research formulate stock advisory recommendations?",
      answer:
        "Our research team blends fundamental analytical models (balance sheets, cash flows, valuation metrics) with technical price action analysis to identify high-probability risk-reward entries.",
    },
    {
      question: "Is NexEra Research SEBI Registered?",
      answer:
        "Yes, NexEra Research operates strictly within the regulatory frameworks governed by SEBI rules and compliance standards to maintain client protection and transparency.",
    },
  ];

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-20 bg-white font-['Plus_Jakarta_Sans',sans-serif]">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Section Header */}
        <div className="text-center mb-12">
          <span className="text-xs font-extrabold uppercase tracking-widest text-emerald-600">
            Got Questions?
          </span>
          <h2 className="text-3xl font-extrabold text-slate-900 mt-2">
            Frequently Asked Questions
          </h2>
        </div>

        {/* FAQ Accordion List */}
        <div className="space-y-4">
          {faqs.map((faq, index) => {
            const isOpen = openIndex === index;
            return (
              <div
                key={index}
                className="border border-slate-200 rounded-2xl p-6 bg-slate-50/50 transition-colors duration-300"
              >
                <button
                  type="button"
                  onClick={() => toggleAccordion(index)}
                  className="w-full flex items-center justify-between cursor-pointer font-bold text-slate-900 text-base text-left outline-none focus:outline-none"
                >
                  <span>{faq.question}</span>
                  <span
                    className={`ml-4 flex-shrink-0 text-emerald-600 transition-transform duration-300 ${
                      isOpen ? "rotate-180" : "rotate-0"
                    }`}
                  >
                    ▼
                  </span>
                </button>

                {isOpen && (
                  <p className="mt-4 text-sm text-slate-600 leading-relaxed transition-all duration-300">
                    {faq.answer}
                  </p>
                )}
              </div>
            );
          })}
        </div>

      </div>
    </section>
  );
}

export default Faq;